import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import LoadingSpinner from '../partials/LoadingSpinner';
import { deleteMetadata } from '../../redux/actions/products';

const InventoryDetailsModal = ({ payload, showInventoryDetailsModal, setShowInventoryDetailsModal, activeProductInventoryDetails, productId, variationId, quantity, deleteOrphanedMetadata, modalY }) => {
  const [deleted, setDeleted] = useState([]);

  const deleteOrphan = (metafieldId) => {
    let newDeleted = [...deleted]
    newDeleted.push(metafieldId);
    setDeleted(newDeleted);
    deleteOrphanedMetadata(payload, productId, variationId, metafieldId);
  }

  return(
    <div className="main-overlay">
      <div style={{ top: `${modalY}px`, position: 'fixed' }} className="main-popup popup-center-always main-popup_center main-popup--thin-padding main-popup_animation">
        <div className="main-popup__container">
          <div className="main-popup__close" onClick={() => setShowInventoryDetailsModal(false)}>
            <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M1.7929 1.7929c.3905-.3905 1.0237-.3905 1.4142 0L9 7.5858l5.7929-5.793c.3905-.3904 1.0237-.3904 1.4142 0 .3905.3906.3905 1.0238 0 1.4143L10.4142 9l5.7929 5.7929c.3905.3905.3905 1.0237 0 1.4142-.3905.3905-1.0237.3905-1.4142 0L9 10.4142l-5.7929 5.7929c-.3905.3905-1.0237.3905-1.4142 0-.3905-.3905-.3905-1.0237 0-1.4142L7.5858 9l-5.793-5.7929c-.3904-.3905-.3904-1.0237 0-1.4142z">
              </path>
            </svg>
          </div>
          <div className="main-popup__subcontainer">
            { !activeProductInventoryDetails &&
              <LoadingSpinner statusText="Loading inventory details" />
            }

            { activeProductInventoryDetails &&
              <>
                <h4>On Hand</h4>
                {quantity}

                <hr />

                <h4>On Order</h4>

                <div className="flex-table">
                  <div className="flex-table__head">
                    <div className="flex-table__col flex-table__col--align-left">Purchase Order #</div>
                    <div className="flex-table__col flex-table__col--align-left">Invoice #</div>
                    <div className="flex-table__col flex-table__col--align-left">Count</div>
                    <div className="flex-table__col flex-table__col--align-left">Expected Date</div>
                    <div className="flex-table__col flex-table__col--align-left"></div>
                  </div>
                  { activeProductInventoryDetails.purchase_orders.map(item => 
                    <div className="flex-table__row">
                      <div className="flex-table__col flex-table__col--align-left">{item.supplier_order_number}</div>
                      <div className="flex-table__col flex-table__col--align-left">{item.invoice_number}</div>
                      <div className="flex-table__col flex-table__col--align-left">{item.count}</div>
                      <div className="flex-table__col flex-table__col--align-left">{item.shipment_expected_at}</div>
                      <div className="flex-table__col flex-table__col--align-left">
                        { item.orphaned && 
                          <>
                            <p>Orphaned</p>
                            <button onClick={() => deleteOrphan(item.metafield_id)}>Delete</button>
                          </>
                        }
                      </div>
                    </div>
                  )}

                </div>
              </>
            }
                

          </div>
        </div>
      </div>
    </div>
  )

}

const mapStateToProps = state => ({
  activeProductInventoryDetails: state.products.activeProductInventoryDetails,
});

const mapDispatchToProps = (dispatch) => ({
  deleteOrphanedMetadata: (payload, productId, variationId, metafieldId) => dispatch(deleteMetadata(payload, productId, variationId, metafieldId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InventoryDetailsModal);
